module.exports = __webpack_public_path__ + "img/Group 83.09cec653.svg";